import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";

class ComponentHTMLPreloader extends BaseComponent {

	/**
	 * Auto scroll до края на страница,
	 * Ако има lazy loading контроли, да се fetch-нат.
	 *
	 * Взема inner HTML-а и го submit-ва с ajax;
	 * От съръвра се връща нов адрес, който трябва да се зареди, за да обходи
	 * автоматично всички страници.
	 *
	 */
	readPreloadedHTML = () => {
		var totalHeight = 0;
		var distance = 300;

		var timer = setInterval(() => {
			var scrollHeight = document.body.scrollHeight;
			window.scroll(0, 0);
			window.scrollBy(0, scrollHeight * 2);
			totalHeight += distance;

			if (totalHeight >= scrollHeight) {
				clearInterval(timer);
				const html = document.getElementById(SHVO.pageAppId).innerHTML;

				let ajaxParam = new AjaxParam();
				ajaxParam.callbackSuccess = (data) => {
					if (data.componentData.new_web_address) {
						this.navigate(data.componentData.new_web_address);
					}
				};

				this.ajaxCall('ActionSaveRawHTML', {
					'page_html': html,
					'page_url': window.location.href
				}, ajaxParam);
			}
		}, 200);
	};

	componentDidMount() {
		super.componentDidMount();

		// Не е инициализиран компонента.
		if (!this.state.componentData) {
			return;
		}

		window.addEventListener('load', this.readPreloadedHTML());
	}

	render() {
		return null;
	}
}


// React Context binding
ComponentHTMLPreloader.contextType = ContextDataStore;

export default ComponentHTMLPreloader;
